 <script>
    import Chartd3 from "../graph/D3BulleGraphe.svelte";// Svend3r bibliotheque D3 pour svelte
    import Spinner from "../../components/ihm/ToolsSpinner.svelte";
    import { coffreByBq,coffre} from "../../store/OpvcmStore";

let show = true;
let showDetail = false;
let fin = false;
let dataGr = [];
let dataGrDetail = [];

/**
 * creation du tableau data pour le graph
 */
async function dataGraph(){
     for(const [key,value] of Object.entries($coffreByBq)){
        dataGr.push({'id': value.NOM, 'value': value.Solde})
     }
     //console.log("dataGr "+JSON.stringify(dataGr))
     show = false;
     return true
}


/**
 * creation du tableau data pour le graph Detail
 */
  const dataGraphDetail = async (listeOP) => {
     for(const [key,value] of Object.entries(listeOP)){
        dataGrDetail.push({'id': value.OP_BQ, 'value': value.OP_MT_VTE})
     }
     //console.log("dataGrDetail "+JSON.stringify(dataGrDetail))
     showDetail = true;
}

  /**
   * permet de selection les opvcm dans la liste complete $coffre
   * @param data
   */
  const listOpvcm = (letype, data) => {
    let result = [];
    if ($coffre != undefined) {
      if (letype != "") {
        result = data.filter((el) => {
          return el.OP_TYPE_PLCMT == letype;
        });
      } else {
        result = $coffre;
      }

      //console.log("listOPvcm => ");
      //console.log(result);
    }
    return result;
  };

    /**
   *
   * @param letype
   * @param data
   */
  const chercher = (letype, data) => {
    const listeData = listOpvcm(letype, data);
     dataGraphDetail(listeData)
    //showDetail = true;
  };


 </script>

<div class="container">
    <h4>Graphe opvcm (bybk)</h4>
{#await $coffreByBq}
    <Spinner/>
{:then record}

{#if record != undefined}
    {#if show}
        {fin = dataGraph()}
    {/if}

    {#if fin}
     <Chartd3 data = {dataGr} />
    {/if}

{:else}
    <h4>erreur magasin</h4>
{/if}

 <button
        on:click={chercher("", $coffre)}
        type="button"
        class="btn btn-primary">Détail</button
      >
      {#if showDetail}
      <h4>Graphe opvcm détail</h4>
        <Chartd3 data = {dataGrDetail} />
      {/if}

{/await}

</div>
